import { BrowserModule } from '@angular/platform-browser';
import { NgModule, APP_INITIALIZER } from '@angular/core';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { FormsModule } from '@angular/forms';
import { HttpClientModule, HTTP_INTERCEPTORS } from '@angular/common/http';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { DecimalPipe, registerLocaleData } from '@angular/common';
import en from '@angular/common/locales/en';
import { ToastrModule } from 'ngx-toastr';
import { AuthGuard } from './auth.guard';
import { NgMultiSelectDropDownModule } from 'ng-multiselect-dropdown';
import { LoaderInterceptorService } from './components/loader/loader-interceptor.service';
import { LoaderComponent } from './components/loader/loader.component';
import { environment } from 'src/environments/environment';
import { DecryptPipe } from './shared/decrypt.pipe';
import { EncryptPipe } from './shared/encrypt.pipe';
import { OauthModule } from '../app/components/OAuth/oauth.module';

registerLocaleData(en);

@NgModule({
  declarations: [AppComponent, LoaderComponent, EncryptPipe, DecryptPipe],
  imports: [
    BrowserModule,
    AppRoutingModule,
    FormsModule,
    HttpClientModule,
    BrowserAnimationsModule,
    ToastrModule.forRoot(),
    NgMultiSelectDropDownModule.forRoot(),
    OauthModule
  ],
  providers: [
    {
      provide: HTTP_INTERCEPTORS,
      useClass: LoaderInterceptorService,
      multi: true
    },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: LoaderInterceptorService,
      multi: true
    },
    EncryptPipe, DecryptPipe, DecimalPipe

  ],
  bootstrap: [AppComponent],
  
})
export class AppModule { }